import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import { isAuthenticated } from '../store/auth';
import META_JSON from './meta.json';

/* eslint no-use-before-define: ["error", { "functions": false }] */
function fromRouteMap(routes) {
    return Object.entries(routes).map(element => fromRoute(element[0], element[1]));
}

function fromRoute(path, meta) {
    const view = meta.title ? meta.title : 'NotFound';
    const page = meta.page ? meta.page : view;
    const redirect = meta.redirect;
    const result = {
        path,
        meta,
    };

    result.name = meta.name;
    result.showToolbar = meta.showToolbar || true;
    result.props = meta.props || false;
    if (page) {
        result.component = () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `../pages/${page}.vue`,
            );
    }

    if (redirect) {
        result.redirect = redirect;
    }

    if (meta.children) {
        result.children = fromRouteMap(meta.children);
    }

    return result;
}

function requiresAutoLogin(to) {
    // TODO: move this as prop into meta.json
    return to.path.startsWith('/requests');
}

Vue.use(VueRouter);
const routes = fromRouteMap(META_JSON);
const router = new VueRouter({
    saveScrollPosition: true,
    mode: 'history',
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.path !== '/login' && to.path !== '/login/callback' && !isAuthenticated()) {
        if (requiresAutoLogin(to)) {
            store.commit('auth/AUTHORIZE', to.fullPath);
        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath,
                    autoLogin: requiresAutoLogin(to),
                },
            });
        }
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js